export const AbasDataTypeInstalacao = [
  {
    label: 'Resumo',
    aba: 'resumo',
    items: [
      {
        label: 'Informações Gerais',
        cols: '3',
        keys: [
          { type: 'string', label: 'OS', key: 'os' },
          { type: 'string', label: 'Regional', key: 'ctrl_regional.regional' },
          { type: 'string', label: 'Velocidade', key: 'velocidade' },
          { type: 'string', label: 'Tipo IP', key: 'tipo_ip' },
          { type: 'string', label: 'Provedor', key: 'provedor.nome' },
          { type: 'formatDate', label: 'Prazo Instalação', key: 'prazo_instalacao' },
          { type: 'formatDateTime', label: 'Data do Pedido', key: 'data_pedido' },
          { type: 'string', label: 'Tipo de Solicitação', key: 'tipo_solicitacao.nome' },
          { type: 'string', label: 'Tipo de Serviço', key: 'tipo_servico.nome' },
          { type: 'string', label: 'Cidade Provedor', key: 'cidade_provedor' },
        ]
      }
    ]
  },
  {
    label: 'Dados Cadastrais',
    aba: 'dados_cadastrais',
    items: [
      {
        label: 'Informações do Cliente',
        cols: '3',
        keys: [
          { type: 'string', label: 'Nome Fantasia', key: 'cliente.nome_fantasia' },
          { type: 'string', label: 'Endereço', key: 'cliente.endereco' },
          { type: 'string', label: 'ID Site Cliente', key: 'cliente.id_site_cliente' },
        ]
      }
    ]
  },
  {
    label: 'Dados do Pedido',
    aba: 'dados_pedido',
    items: [
      {
        label: 'Informações do Pedido',
        cols: '3',
        keys: [
          { type: 'string', label: 'Contrato Guarda-chuva', key: 'contrato_guarda_chuva' },
          { type: 'string', label: 'Custo de Instalação', key: 'custo_instalacao' },
          { type: 'string', label: 'Mensalidade', key: 'mensalidade' },
          { type: 'string', label: 'Prazo Contratual', key: 'ctrl_prazo_contratual.prazo' },
          { type: 'string', label: 'CNL', key: 'cnl' },
          { type: 'string', label: 'SGP ID', key: 'sgp_id' },
          { type: 'string', label: 'Cód. Circuito', key: 'cod_circuito' },
          { type: 'string', label: 'Ponta', key: 'ponta' },
          { type: 'string', label: 'Pedido CLA', key: 'pedido_cla' },
        ]
      }
    ]
  },
  {
    label: 'Informações do Provedor',
    aba: 'provedor',
    items: [
      {
        label: 'Dados do Provedor',
        cols: '3',
        keys: [
          { type: 'string', label: 'Nome Provedor', key: 'provedor.nome' },
          { type: 'string', label: 'Responsável', key: 'provedor.responsavel' },
          { type: 'string', label: 'E-mail Responsável', key: 'provedor.email_responsavel' },
          { type: 'string', label: 'Telefone Responsável', key: 'provedor.telefone_responsavel' },
          { type: 'string', label: 'Regional', key: 'provedor.regional' },
          { type: 'string', label: 'UF', key: 'provedor.uf' },
          { type: 'string', label: 'CM', key: 'provedor.cm' },
          { type: 'string', label: 'Cluster', key: 'provedor.cluster' },
        ]
      }
    ]
  }
]
